export class SetLoading {
    static readonly type = '[Loading] Set Loading';
    constructor(public payload: boolean ) {}
  }
  